module.exports = __webpack_public_path__ + "static/media/Envelope@3x.8cfe1a90.png";